import { post } from "@futuri/cloudsso-client/src/client/util";
import { POST } from "@futuri/cloudsso-client/src/client/types/productType";
import store from "./store";
import {
  RequestPostLoginCredentialRequest,
  RequestPostLoginCredentialResponse
} from "@futuri/cloudsso-client/src/client/types/api";
import { ProductInstanceResult } from "@futuri/cloudsso-client/src/client/types/productInstances";
import { Cluster } from "./store/modules/api";
import {
  PRODUCTION,
  StageType
} from "@futuri/cloudsso-client/src/client/types/stages";

// export const requestPostLoginCredential = async (station: string, instanceId: string): Promise<RequestPostLoginCredentialResponse> => {
//     // const baseUrl = store.getters.baseUrl
//     const email = store.getters.email

//     const req: RequestPostLoginCredentialRequest = {
//       product: POST,
//       station,
//       email,
//     }

//     const creds = await post<RequestPostLoginCredentialRequest, RequestPostLoginCredentialResponse>(`${baseUrl}requestPostLoginCredential`, req)
//     return creds
// }

export const requestPostLoginCredential = async (
  station: string,
  stage: StageType = PRODUCTION
): Promise<RequestPostLoginCredentialResponse> => {
  const baseUrl = store.getters.baseUrl;
  const email = store.getters.email;

  const req: RequestPostLoginCredentialRequest = {
    product: POST,
    station,
    email
  };

  const creds = await post<
    RequestPostLoginCredentialRequest,
    RequestPostLoginCredentialResponse
  >(`${baseUrl}requestPostLoginCredential`, req);
  return creds;
};

// // export const getRedirectUrl = async (email: string, station: string, instanceId: string, originalRedirectUrl: string): Promise<string> => {
// export const getRedirectUrl = async (instance: ProductInstanceResult): Promise<string> => {
//     const { apiKey, compatibleUsername } = await requestPostLoginCredential(station, instanceId)
//     const safeUsername = encodeURIComponent(email)
//     const safeStation = encodeURIComponent(station)
//     const safeCompatibleUsername = encodeURIComponent(compatibleUsername ?? '')
//     const safeApiKey = encodeURIComponent(apiKey || '')

//     // const fixUrl = () => {
//     //   const isAdmin = email === 'admin@futurimedia.com'
//     //   if (originalRedirectUrl?.match(/do_login/) !== null) {
//     //     return `${originalRedirectUrl}?username=${isAdmin ? safeCompatibleUsername : safeUsername}&api_key=${safeApiKey}&current_station=${safeStation}`
//     //   } else {
//     //     return `${originalRedirectUrl}${safeStation}/postv2.html?username=${safeCompatibleUsername}&api_key=${safeApiKey}#/shows`
//     //   }
//     // }

//     const finalRedirectUrl = fixUrl()
//     return finalRedirectUrl
// }

export const toCluster = (instance: ProductInstanceResult): Cluster => {
  return {
    instance,
    onClick: (event: MouseEvent) => {
      console.log("clicked: ", event);
    },
    get redirectUrl() {
      return this.instance?.redirectUrl;
    }
  };
};
